import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs, DataSourceChangedEventArgs } from '@syncfusion/ej2-angular-grids';
import { HttpBackend, HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { LocalStorageService } from '../localStorage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class ItvendorService extends Subject<DataStateChangeEventArgs> {
  private httpClient: HttpClient;
  constructor(private handler: HttpBackend, private http: HttpClient, private storageService: LocalStorageService) {
    super();
    this.httpClient = new HttpClient(handler);

   }

   handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
  //  window.alert(errorMessage);
  console.log("Error:",errorMessage);
    return throwError(errorMessage);
  }

  // Create Vendors
  createvendors(user: Object): Observable<Object> {
    console.log("In createVendors method, Vendors: ", user);
    return this.http.post(`${environment.apiUrl}/vendors`, user).pipe(catchError(this.handleError));
  }

  // Get vendors by Id Get
  getVendors(id: number): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/vendors/${id}`).pipe(catchError(this.handleError));
  }


  //Delete vendors by Id Delete
  deleteVendors(id: number): Observable<Object> {
    return this.http.delete(`${environment.apiUrl}/vendors/${id}`).pipe(catchError(this.handleError));
  }

  //Update vendors by Id Put
  updateVendors(user: Object,id: number): Observable<Object> {
    console.log("In createUser method, user: ", user);
    return this.http.put(`${environment.apiUrl}/vendors/${id}`, user).pipe(catchError(this.handleError));
  }

   //Get All vendors by Id Get
   getAllVendors(): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/vendors`).pipe(catchError(this.handleError));
  }
}
